import { IJob } from 'src/gen';

export type JobFit = 'great' | 'good' | 'ok' | null;

export enum JobFitValues {
  great,
  good,
  ok
}

export interface JobCardVo extends IJob {
  fit: JobFit;
  education?: string;
  salary?: string;
  workActivities?: Skills[];
  knowledge?: Skills[];
  displaySkills?: Skills[];
  abilities?: Skills[];
  educationRequirements?: any;
  typicalEducation?: string | null;
  videoUrl?: any;
  imageUrl?: any;
  thumbnailUrl?: any;
  technologies?: any;
  occupationTasks?: any[];
  occupationKSAs?: any[];
  minimumAnnualSalary?: any;
  maximumAnnualSalary?: any;
  medianAnnualSalary?: any;
  interests?: any;
}

export interface Skills {
  displayName: string;
  active: boolean;
}
